import { render, staticRenderFns } from "./FormInputUploadImagem.vue?vue&type=template&id=e64f4322"
import script from "./FormInputUploadImagem.vue?vue&type=script&lang=js"
export * from "./FormInputUploadImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports